import React from 'react';
import './opettajat.css';
import Opet from '../images/Opettajat2026.jpg';
import opetJson from '../opettajat/opet2.json';

const Opettajat = () => {
  return (
    <div style={{ marginTop: '120px' }} className="container opettajat-container">
      <img
        style={{ width: '100%', borderRadius: '20px', marginTop: '10px', maxHeight: '800px', objectFit: 'cover' }}
        src={Opet}
        alt="Kum-opettajat"
      />

      <p className="email-info-text">
        Sähköpostiosoitteet ovat muotoa etunimi.sukunimi@jarvenpaa.fi
      </p>

      <div className="table-responsive">
        <table className="opeTable">
          <thead>
            <tr>
              <th>Nimi</th>
              <th>Opetusaine</th>
            </tr>
          </thead>
          <tbody>
            {opetJson.map((opettaja, index) => (
              <tr key={index}>
                <td className="ope-name">{opettaja.name}</td>
                <td>{opettaja.data}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Opettajat;